import React from "react";
import ErrorField from "./error";
import Big from "big.js";
import { CurrencyField } from "components/support";
import { observer } from "mobx-react";

const SellValueField = ({ errors, row, onChange }) => {
  const { sell_value } = row;
  let parsedSellValue = "0.00";
  if (sell_value && sell_value.length !== 0) {
    parsedSellValue = Big(sell_value)
      .div(100)
      .toFixed(2);
  }
  const foundErrors = errors.find(v => v.name === row.name);
  const hasErrors =
    foundErrors && !!foundErrors.errors && !!foundErrors.errors.sell_value;

  return (
    <div>
      <CurrencyField
        value={parsedSellValue}
        onChange={(_, value) =>
          onChange(
            Big(value)
              .times(100)
              .toFixed(0)
          )
        }
        unit="R$ "
        fullWidth
      />
      {hasErrors && <ErrorField error={foundErrors.errors.sell_value} />}
    </div>
  );
};

export default observer(SellValueField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/sell-value.js